import { EntityState } from '@reduxjs/toolkit'
import { normalizeFilters } from '@user/components/Filters'
import { Draft } from 'immer'
import { IImport, ImportPageState } from './typings'
import { ImportFilterSet } from './filters'

export const updateFilterState = (
  state: Draft<EntityState<IImport> & ImportPageState>,
  filterSet: ImportFilterSet,
) => {
  state.shouldFetchList = true
  state.filterSet = normalizeFilters<IImport, ImportFilterSet>(filterSet)
  state.filterSet.orderBy = filterSet.orderBy
}
